import React, { FC, useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../store";
import { TokenDataNew } from "../store/user/types";

const mapState = (state: RootState) => ({
    tokens: state.user.tokens,
  });
  
  const mapDispatch = {
    setTokens: () => ({ tokens: [] }),
  };
  
  const connector = connect(mapState, mapDispatch);
  
  type PropsFromRedux = ConnectedProps<typeof connector>;
  
  type Props = PropsFromRedux & { tokens: TokenDataNew[] };

const AssetValue: FC<Props> = (props: Props) => {
    const [totalValue, setTotalValue] = useState<number>(0);

    const calcTotal = () => {
        let totalVal = 0;
        for (const token of props.tokens) {
            const value = token.value;
            totalVal += value;
        }
        setTotalValue(totalVal);
    }

    useEffect(() => {
        calcTotal()
    }, [props])

  return (
    <div className="text-5xl text-white">
      {"$" + totalValue.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
    </div>
  );
};

export default connector(AssetValue);
